// import Button from 'react-bootstrap/Button';
// import Card from 'react-bootstrap/Card';
import InfoCard from '../components/card';
import { useRef } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
function InfoCards() {
    const infoRef = useRef<HTMLDivElement>(null);
    return (
        <Row className="section--info" id="section--info" ref={infoRef}>
            <Col md={12} className="info__content">
                {/* Collaborating closely with our clients, we craft tailor-made websites that align perfectly with their unique goals and vision. */}
                <InfoCard count={1} title={"Innovative Solutions"} content={"We embrace creativity and technology to deliver software solutions that push boundaries and drive results."} />
                <InfoCard count={2} title={"User-Centric Design"} content={"Prioritizing user experience, we design intuitive and visually engaging interfaces that captivate and connect."} />
                <InfoCard count={3} title={"Agile Development"} content={"Our adaptive development process ensures timely delivery of robust and scalable software tailored to evolving needs."} />
                <InfoCard count={1} title={"End-to-End Support"} content={"From concept to launch, we provide comprehensive support to ensure your project succeeds every step of the way."} />
                <InfoCard count={2} title={"Secure and Reliable"} content={"With a focus on security and reliability, we develop software that gives you peace of mind while meeting industry standards."} />
                <InfoCard count={3} title={"Future-Ready Technology"} content={"Leveraging the latest tools and frameworks, we create software designed to grow and adapt with your business."} />
            </Col>
        </Row>
    );
}

export default InfoCards;